module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "defaultActive": "server",
      "uniqueOpened": true,
      "router": true,
      "theme": "dark"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/server"
    }
  }, [_vm._v("服务器管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/save"
    }
  }, [_vm._v("存档管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/jar"
    }
  }, [_vm._v("版本管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/setting"
    }
  }, [_vm._v("设置")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3342ef80"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/Menu.vue
// module id = 157
// module chunks = 1